import { fromJS } from "immutable";
import { CreateProcess } from "redux-process";

export const GetCompanySettings = CreateProcess({
	method: "GET",
	name: "GetCompanySettings",
	type: "SETTINGS:GETCOMPANY",

	request: () => ({
		url: "/api/settings/company/",
	}),

	success: (response) => fromJS(response.data),
});

export const getAsapAndDeferredNotification = CreateProcess({
	method: "GET",
	name: "getAsapAndDeferredNotification",
	type: "SETTINGS:GETASAPANDDEFERREDNOTIFICATIONS",

	request: () => ({
		url: "/api/notifications/asap-deferred/",
	}),

	success: (response) => fromJS(response.data),
});

export const setAsapAndDeferredNotification = CreateProcess({
	method: "PATCH",
	name: "setAsapAndDeferredNotification",
	type: "SETTINGS:SETASAPANDDEFERREDNOTIFICATIONS",

	request: (props) => ({
		url: "/api/notifications/asap-deferred/",
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

export const getWeeklyDigestSettings = CreateProcess({
	method: "GET",
	name: "getWeeklyDigestSettings",
	type: "SETTINGS:GETWEEKLYDIGESTSETTINGS",

	request: () => ({
		url: "/api/notifications/digest/",
	}),

	success: (response) => fromJS(response.data),
});

export const setWeeklyDigestNotification = CreateProcess({
	method: "PATCH",
	name: "setWeeklyDigestNotification",
	type: "SETTINGS:SETWEEKLYDIGESTNOTIFICATIONS",

	request: (props) => ({
		url: "/api/notifications/digest/",
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

export const getAdminWeeklyDigestSettings = CreateProcess({
	method: "GET",
	name: "getAdminWeeklyDigestSettings",
	type: "SETTINGS:GETADMINWEEKLYDIGESTSETTINGS",

	request: () => ({
		url: "/api/notifications/admin-digest/",
	}),

	success: (response) => fromJS(response.data),
});

export const setAdminWeeklyDigestNotification = CreateProcess({
	method: "PATCH",
	name: "setAdminWeeklyDigestNotification",
	type: "SETTINGS:SETADMINWEEKLYDIGESTNOTIFICATIONS",

	request: (props) => ({
		url: "/api/notifications/admin-digest/",
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

export const getTimezones = CreateProcess({
	method: "GET",
	name: "getTimezones",
	type: "SETTINGS:GETTIMEZONES",

	request: () => ({
		url: "/api/timezones/",
	}),

	success: (response) => fromJS(response.data),
});

export const getUserSettings = CreateProcess({
	method: "GET",
	name: "getUserSettings",
	type: "SETTINGS:GETUSERSETTINGS",

	request: () => ({
		url: "/api/user/settings/",
	}),

	success: (response) => fromJS(response.data),
});

export const changeUserSetting = CreateProcess({
	method: "PATCH",
	name: "changeUserSetting",
	type: "SETTINGS:UPDATEUSERSETTING",

	request: (props) => ({
		url: "/api/user/settings/",
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

export const changeUserDefaultCompany = CreateProcess({
	method: "POST",
	name: "setUserDefaultCompany",
	type: "SETTINGS:UPDATEDEFAULTCOMPANY",

	request: (props) => ({
		url: "/api/user/default-company/",
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

// NOTIFICATION TEMPLATES
export const getAsapAndDeferredNotificationSettingsTemplate = CreateProcess({
	method: "GET",
	name: "getAsapAndDeferredNotificationSettingsTemplate",
	type: "SETTINGS:GETASAPANDDEFERREDNOTIFICATIONSTEMPLATE",

	request: () => ({
		url: "/api/notifications/asap-deferred/template/",
	}),

	success: (response) => fromJS(response.data),
});

export const getWeeklyDigestSettingsTemplate = CreateProcess({
	method: "GET",
	name: "getWeeklyDigestSettingsTemplate",
	type: "SETTINGS:GETWEEKLYDIGESTSETTINGSTEMPLATE",

	request: () => ({
		url: "/api/notifications/digest/template/",
	}),

	success: (response) => fromJS(response.data),
});

export const getAdminWeeklyDigestSettingsTemplate = CreateProcess({
	method: "GET",
	name: "getAdminWeeklyDigestSettingsTemplate",
	type: "SETTINGS:GETADMINWEEKLYDIGESTSETTINGSTEMPLATE",

	request: () => ({
		url: "/api/notifications/admin-digest/template/",
	}),

	success: (response) => fromJS(response.data),
});

export const setAsapAndDeferredNotificationSettingsTemplate = CreateProcess({
	method: "PATCH",
	name: "setAsapAndDeferredNotificationSettingsTemplate",
	type: "SETTINGS:SETASAPANDDEFERREDNOTIFICATIONSTEMPLATE",

	request: (props) => ({
		url: "/api/notifications/asap-deferred/template/",
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

export const setWeeklyDigestSettingsTemplate = CreateProcess({
	method: "PATCH",
	name: "setWeeklyDigestSettingsTemplate",
	type: "SETTINGS:SETWEEKLYDIGESTSETTINGSTEMPLATE",

	request: (props) => ({
		url: "/api/notifications/digest/template/",
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

export const setAdminWeeklyDigestSettingsTemplate = CreateProcess({
	method: "PATCH",
	name: "setAdminWeeklyDigestSettingsTemplate",
	type: "SETTINGS:SETADMINWEEKLYDIGESTSETTINGSTEMPLATE",

	request: (props) => ({
		url: "/api/notifications/admin-digest/template/",
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

export const setSftpPassword = CreateProcess({
	method: "POST",
	name: "setSftpPassword",
	type: "SETTINGS:SET_SFTP_PASSWORD",

	request: () => ({
		url: "/api/sftp-credentials/",
	}),

	success: (response) => response.data,
});

export const getSftpPassword = CreateProcess({
	method: "GET",
	name: "getSftpPassword",
	type: "SETTINGS:GET_SFTP_PASSWORD",

	request: () => ({
		url: "/api/sftp-credentials/",
	}),

	success: (response) => response.data,
});

export const disableSftpPassword = CreateProcess({
	method: "DELETE",
	name: "disableSftpPassword",
	type: "SETTINGS:DISABLE_SFTP_PASSWORD",

	request: () => ({
		url: "/api/sftp-credentials/",
	}),

	success: (response) => response.data,
});
